import { CardImgBuildSmartAiBased, CardImgBuildSmartFastTarck, CardImgBuildSmartHumanCentered, LogoBuildSmartGlobalBusinessesGlowy, LogoBuildSmartGlobalBusinessesHealthPrime, LogoBuildSmartGlobalBusinessesNyxara, LogoBuildSmartGlobalBusinessesPegasus, LogoBuildSmartGlobalBusinessesVodacom } from "@/lib/images";
import { StaticImageData } from "next/image";

// Heading
export const Heading_Section_BuildSmart = {
    build_smart: "Build Smarter, Ship Faster"
}

// Sub Heading
export const Sub_Heading_Section_BuildSmart = {
    from_mpv: "From MVPs to full-scale systems, we combine fast-paced development, UX precision, and smart automation—so your product gets to market faster, performs better, and grows effortlessly.",
    // so_your:" —so your product gets to market faster, performs better, and grows effortlessly."
}


// Cards View 
interface ICardsSectionBuildSmart {
    img: StaticImageData;
    alt: string
    title: string;
    desc: string;
    list_1?: string;
    list_2?: string;
}

export const Cards_Section_Build_Smart: ICardsSectionBuildSmart[] = [
    {
        img: CardImgBuildSmartFastTarck,
        alt: "Fast-Track Dev Cycles",
        title: "Fast-Track Dev Cycles ⏩",
        desc: "Launch in weeks, not months.",
        list_1: "→ Agile sprints, CI/CD pipelines, and real-time stakeholder reviews."
    },
    {
        img: CardImgBuildSmartHumanCentered,
        alt: "Human-Centered Experience",
        title: "Human-Centered Experience 🤌🏻",
        desc: "Designs that don’t just look good—they work.",
        list_1: "→ Crafted for real users with real goals.",
        list_2: "→ Practical UX over flashy designs."
    },
    {
        img: CardImgBuildSmartAiBased,
        alt: "AI Based Data Driven Dashboards",
        title: "AI Based Data Driven Dashboards 🔭",
        desc: "From business dashboards to embedded analytics, we ensure your data isn’t just collected—it’s actionable.",

    },
]


// Global Businesses Logos & Heading

export const Heading_Global_Businesses_BuildSmart = {
    heading: "Trusted by global businesses",
}

interface IBrands_Section_Build_Smart {

    img: StaticImageData;
    alt: string;
}

export const Brand_Logo_Section_Build_Smart: IBrands_Section_Build_Smart[] = [
    {
        img: LogoBuildSmartGlobalBusinessesGlowy,
        alt: "Glowy"
    },
    {
        img: LogoBuildSmartGlobalBusinessesVodacom,
        alt: "Vodacom"
    },
    {
        img: LogoBuildSmartGlobalBusinessesHealthPrime,
        alt: "Health Prime"
    },
    // {
    //     img: LogoBuildSmartGlobalBusinessesEnrollHealth,
    //     alt: "Enroll Health"
    // },
    {
        img: LogoBuildSmartGlobalBusinessesNyxara,
        alt: "Nyxara"
    },
    // {
    //     img: LogoBuildSmartGlobalBusinessesMillennium,
    //     alt: "Millennium Health Advisors"
    // },
    {
        img: LogoBuildSmartGlobalBusinessesPegasus,
        alt: "Pegasus"
    },
    // {
    //     img: LogoBuildSmartGlobalBusinessesSignit,
    //     alt: "Signit"
    // },
    // {
    //     img: LogoBuildSmartGlobalBusinessesVindico,
    //     alt: "Vindico"
    // },
    // {
    //     img: LogoBuildSmartGlobalBusinessesVindicoPay,
    //     alt: "Vindico Pay"
    // },
    // {
    //     img: LogoBuildSmartGlobalBusinessesEnrollHealthTechnology,
    //     alt: "Enroll Health Technology"
    // },
]
